import { atom } from "recoil";
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'ministermore',
  storage: sessionStorage,
});

export interface AuthState {
  token: string;
  storeId: number | null;
  isSuperAdmin: boolean;
  isMasterAdmin: boolean;
}

export const authState = atom<AuthState | null>({
  key: 'authState',
  default: null,
  effects_UNSTABLE: [persistAtom],
});
